/* eslint-disable  @typescript-eslint/no-explicit-any */
export default class Utils {
    static fromEpochToDate(epoch: number): Date {
        return new Date(epoch * 1000);
    }
    static fromDateToEpochUnix(date: Date): number {
        return Math.floor(new Date(date).getTime());
    }
    static fromDateToEpoch(date: Date): number {
        return Math.floor(new Date(date).getTime());
    }
    static fromDateToEpochRemoveSecond(date: Date): number {
        return Math.floor(new Date(date).getTime() / 1000);
    }
    // Below function will convert the human readable date of DD/MM/YYYY format into the date object which is given to the mat-datepicker
    static convertToDateObject(dateString: string): Date | null {
        if (!dateString) return null;
        const [day, month, year] = dateString.split('/').map(Number);
        return new Date(year, month - 1, day);
    }

    static getUpcomingMinutesEpoch(minutes = 0): number {
        return Math.floor(Date.now() / 1000 + minutes * 60);
    }
    static removeSpecialCharacter(value: string): string {
        const newVal = value.replace(/[^\w\s]/gi, ' ');
        return newVal;
    }
    static idComparer(o1: any, o2: any): boolean {
        if (o1 && o2) {
            return o1.id === o2.id;
        } else {
            return Number.isNaN(o2);
        }
    }

    static keyComparer(o1: any, o2: any): boolean {
        if (o1 && o2) {
            return o1 && o2 ? o1.key === o2.key : true;
        } else {
            return Number.isNaN(o2);
        }
    }

    static codeComparer(o1: any, o2: any) {
        if (o1 && o2) {
            return o1 && o2 ? o1 === o2 : true;
        } else {
            return Number.isNaN(o2);
        }
    }

    static headerCodeComparer(o1: any, o2: any) {
        if (o1 && o2) {
            return o1 && o2 ? o1.code === o2.code : true;
        } else {
            return Number.isNaN(o2);
        }
    }

    static copyObject(object: any): any {
        return JSON.parse(JSON.stringify(object));
    }

    // Function is used if you want to download the file which is already in your projects assets
    static downloadFile(fileName: string, filePath: string) {
        const link = document.createElement('a');
        link.href = filePath;
        link.download = fileName;
        link.click();
    }
}
